import { readonly, ref, type Ref } from 'vue';
import { useNativeEvent } from './useNativeEvent';

/**
 * État de la connexion réseau.
 *
 * `navigator.onLine` seul est peu fiable — il ne dit que « une interface est
 * active », pas « le serveur est joignable ». On s'en contente pour l'affichage
 * d'un bandeau, mais jamais pour décider d'un appel : c'est l'échec de la
 * requête qui fait foi.
 */
export function useOnline(): Readonly<Ref<boolean>> {
	const online = ref(typeof navigator === 'undefined' ? true : navigator.onLine);

	useNativeEvent(window, 'online', () => (online.value = true));
	useNativeEvent(window, 'offline', () => (online.value = false));

	return readonly(online);
}
